export abstract class BaseAvatarStreamingService {
	abstract createNewSession(configuration: any, videoHtmlElement, welcomeMessage: string);
	abstract closeConnectionHandler();
	abstract talk(message: string);
	abstract stopStreamHandler();
}